import { useCreateMutation } from '../../CRUD';
import { TBookAvailability } from './types';
import { axiosService } from '../../services/axiosService';
import { keys } from './crud';

export const useEditAvailabilityBook = () => {
  async function queryFn(availability: TBookAvailability) {
    const { data } = await axiosService.request({
      url: `${keys.basicUrlPath}/${availability._id}/book`,
      method: 'put',
      data: availability,
    });
    return data;
  }

  return useCreateMutation(keys.all, queryFn, keys.fetchKey);
};
